import { Flex, Heading, Icon, styled } from '@kandji-inc/nectar-ui';
import type { ReactNode } from 'react';

type PageHeaderLevel2Props = {
  title: string;
  icon?: string;
  children?: ReactNode;
};

const PageHeaderLevel2 = (props: PageHeaderLevel2Props) => {
  const StyledHeaderIcon = styled(Flex, {
    padding: '$2',
    backgroundColor: '$blue10',
    borderRadius: '$round',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <>
      <Flex gap="sm" alignItems="center">
        {props.icon && (
          <StyledHeaderIcon>
            <Icon name={props.icon} color="var(--colors-blue60)" />
          </StyledHeaderIcon>
        )}

        <Heading size="2"> {props.title} </Heading>

        {props.children}
      </Flex>
    </>
  );
};

export default PageHeaderLevel2;
